<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-thaicuisine">
      <div class="px-3 col-3 p-0">
        <div class="heading-thaicuisine">{{ $t("result.round") }}</div>
        <div class="text-subhead-thaicuisine">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-thaicuisine">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-thaicuisine">
          {{ data.count === 0
            ? data.bet
            : data.detail.summary[data.count].bet.amount | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-thaicuisine">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-thaicuisine">
          {{ winlose | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-thaicuisine">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-thaicuisine">
          {{ balance | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-thaicuisine pt-3">
      <div class="text-games-thaicuisine">{{ "Thai Cuisine" }}</div>
      <div class="text-subgame-thaicuisine">{{ $t("thaicuisine.name") }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0 align-items-center" style="margin-top: 40px">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="state === 'FREESPIN' || state === 'FREERESPIN' || state === 'RESPIN'"
            class="fas fa-caret-left arrow-side-thaicuisine" @click="delCount()"></i>
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex flex-row justify-content-center">
            <img v-if="result.win > 0" class="d-flex col-8 mb-4"
              :src="require(`../../assets/resultGame/thaicuisine/win.png`)" alt="" />
            <img v-else-if="result.win == 0 && nextState === '-'" class="d-flex col-8 mb-4"
              :src="require(`../../assets/resultGame/thaicuisine/lose.png`)" alt="" />
          </div>
          <div class="table-thaicuisine d-flex flex-row slot-container">
            <div class="d-flex flex-column">
              <div v-for="(symbol, index) in this.reels[0]" :key="index">
                <div style=" position: relative;text-align: center; ">
                  <img class="icon-symbol-thaicuisine"
                    :src="require(`../../assets/resultGame/thaicuisine/symbol_${symbol}.png`)" alt="" />
                  <div v-if="symbol === 10" class="multiplier-text">x{{ multiplierReel[0][index] }}</div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row slot-container">
              <div class="d-flex flex-column">
                <div v-for="(symbol, index) in this.reels[1]" :key="index">
                  <div style=" position: relative;text-align: center; ">
                    <img class="icon-symbol-thaicuisine"
                      :src="require(`../../assets/resultGame/thaicuisine/symbol_${symbol}.png`)" alt="" />
                    <div v-if="symbol === 10" class="multiplier-text">x{{ multiplierReel[1][index] }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row slot-container">
              <div class="d-flex flex-column">
                <div v-for="(symbol, index) in this.reels[2]" :key="index">
                  <div style=" position: relative;text-align: center; ">
                    <img class="icon-symbol-thaicuisine"
                      :src="require(`../../assets/resultGame/thaicuisine/symbol_${symbol}.png`)" alt="" />
                    <div v-if="symbol === 10" class="multiplier-text">x{{ multiplierReel[2][index] }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row slot-container">
              <div class="d-flex flex-column">
                <div v-for="(symbol, index) in this.reels[3]" :key="index">
                  <div style=" position: relative;text-align: center; ">
                    <img class="icon-symbol-thaicuisine"
                      :src="require(`../../assets/resultGame/thaicuisine/symbol_${symbol}.png`)" alt="" />
                    <div v-if="symbol === 10" class="multiplier-text">x{{ multiplierReel[3][index] }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row slot-container">
              <div class="d-flex flex-column">
                <div v-for="(symbol, index) in this.reels[4]" :key="index">
                  <div style=" position: relative;text-align: center; ">
                    <img class="icon-symbol-thaicuisine"
                      :src="require(`../../assets/resultGame/thaicuisine/symbol_${symbol}.png`)" alt="" />
                    <div v-if="symbol === 10" class="multiplier-text">x{{ multiplierReel[4][index] }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row slot-container">
              <div class="d-flex flex-column">
                <div v-for="(symbol, index) in this.reels[5]" :key="index">
                  <div style=" position: relative;text-align: center; ">
                    <img class="icon-symbol-thaicuisine"
                      :src="require(`../../assets/resultGame/thaicuisine/symbol_${symbol}.png`)" alt="" />
                    <div v-if="symbol === 10" class="multiplier-text">x{{ multiplierReel[5][index] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!result.isEndRound" class="fas fa-caret-right arrow-side-thaicuisine" @click="addCount()"></i>
        </div>
      </div>

      <div class="text-center py-4 text-games-thaicuisine">
        <h1 v-if="state === 'FREESPIN'"> FREESPIN {{ result.freeSpin.round }}/{{ result.freeSpin.remain }}
        </h1>
        <h1 v-else-if="state === 'FREERESPIN'"> FREESPIN {{ result.freeSpin.round }}/{{ result.freeSpin.remain
        }} (RESPIN) </h1>
        <h1 v-else-if="state === 'SPIN'"> SPIN {{ result.round }}/{{ data.detail.summary.length }} </h1>
        <h1 v-else-if="state === 'RESPIN'"> RESPIN {{ result.round }}/{{ data.detail.summary.length }} </h1>
      </div>
      <div v-if="result.featureBuy" class="text-subgame-thaicuisine"> Feature Buy </div>
      <div
        v-if="result.winnings.length > 0 || state === 'FREERESPIN' && (nextState === 'FREESPIN' || nextState === '-')"
        class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3" />
        <div class="text-detail align-items-center d-flex px-3"> {{ $t("result.detail") }} </div>
        <hr class="line col-3" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div v-if="state === 'FREERESPIN' && (nextState === 'FREESPIN' || nextState === '-')"
          class="col-12 multiplier-box-thaicuisine align-items-center">
          <h1 class="my-1 green">{{ $t("thaicuisine.multiplier.title") }} x{{ this.multiplier }}</h1>
          <h1 class="my-1 green"> {{ $t("thaicuisine.totalwin") }}
            {{ ((result.win / this.multiplier)) | currencyFormatter }}
            x {{ this.multiplier }}
            = {{ (result.win) | currencyFormatter }}</h1>
        </div>
      </div>
      <div v-if="!!result.winnings && result.winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
      </div>
      <div class=" bet-box-thaicuisine col-12 ml-auto mr-auto flex-col">
        <div class="bet-wrapper justify-content-between item d-flex col-12" v-for="(detail, index) in result.winnings"
          :key="index">
          <div class="d-flex flex-row">
            <img class="icon-detail-thaicuisine"
              :src="require(`../../assets/resultGame/thaicuisine/symbol_${detail.symbol}.png`)" alt="" />
            <div class="d-flex text-win align-items-center justify-content-center">
              <p class="my-1 green">{{ ` ${detail.count} ` + $t("result.kind") }}</p>
            </div>
          </div>
          <div class="d-flex text-win justify-content-center align-items-center px-3">
            <p class="my-1 green"> {{ currency }} {{ detail.amount | currencyFormatter }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-thaicuisine",
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: "",
      time: "",
      result: this.data,
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      multiplierReel: this.data.detail.multiplierReels ? this.data.detail.multiplierReels : null,
      state: "SPIN",
      pages: 0,
      multiplier: 0,
      reels: [],
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName(
        "header-thaicuisine"
      )[0].offsetHeight;
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.state = result.state;
      this.nextState = result.nextState;
      this.reels = result.reels;
      this.result = result;
      this.isEndRound = result.isEndRound;
      this.winnings = result.winnings;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.multiplierReel = result.multiplierReels;

      if (this.state === 'SPIN' || this.state === 'RESPIN')
        this.multiplier = result.multiplier;
      else
        this.multiplier = result.multiplier;

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  },
};
</script>
<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  margin: 0;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.text-win {
  height: 144px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-thaicuisine {
  width: 140px;
  height: 144px;
  padding: 4px;
}

.icon-bonus-thaicuisine {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-thaicuisine {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 10vw;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
}

.bet-box-thaicuisine {
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.multiplier-box-thaicuisine {
  border-radius: 10px;
  min-height: 50px;
  max-height: 100px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-thaicuisine {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-thaicuisine .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-thaicuisine .bet-wrapper-thaicuisine:not(:first-child) .item {
  margin-top: 10px;
  /* width: 800px; */
}

.bet-wrapper-thaicuisine,
.result-wrapper {
  font-size: 35px;
  /* width: 800px; */
}

.header-thaicuisine {
  background: #A7CC2D;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-thaicuisine>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-thaicuisine {
  color: #000000;
  text-align: center;
}

.content-result-thaicuisine {
  background: #432615;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-thaicuisine {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-thaicuisine {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-thaicuisine {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-thaicuisine {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: 30px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-thaicuisine {
  position: relative;
  width: 100%;
  /* padding: 5%; */
}

.bet-box-thaicuisine {
  min-width: 600px;
  max-width: auto;
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-108px, 0px);
}

.icon-symbol.-level1 {
  width: 109px;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 109px;
  height: 176px;
}

.icon-symbol.-level3 {
  width: 109px;
  height: 266px;
}

.icon-symbol.-level4 {
  width: 112px;
  height: 352px;
}

.table-thaicuisine {
  background: url("~@/assets/resultGame/thaicuisine/slotmachine.png") no-repeat;
  z-index: 5;
  background-size: 620px 630px;
  /* set Bg Table HERE */
  width: 620px;
  height: 630px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 200px;
  position: absolute;
  z-index: 0;
  transform: translate(0px, -157px);
}

.slot-container {
  position: relative;
  align-items: center;
}

.multiplier-container {
  width: 100%;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 689px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-thaicuisine {
    background-size: 649px 660px;
    width: 649px;
    height: 660px;
    transform: translate(0px, -114px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-thaicuisine {
    min-width: 580px;
    max-width: auto;
    height: 100%;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px;
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-126px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 104px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 209px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 314px;
  }

  .icon-symbol.-level4 {
    width: 127px;
    height: 419px;
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-thaicuisine,
  .result-wrapper {
    font-size: 33px;
    /* width: 800px; */
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-127px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 105px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 210px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 315px;
  }

  .icon-symbol.-level4 {
    width: 126px;
    height: 419px;
  }
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 35px;
}

.win-box {
  width: 689px;
}

@media screen and (max-width: 770px) {
  .heading-thaicuisine {
    font-size: 18px;
  }

  .table-thaicuisine {
    background-size: 638px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-thaicuisine {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-thaicuisine {
    min-width: 430px;
    max-width: auto;
    height: 100%;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 67%;
    transform: translate(104px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }

  .multiplier-container {
    width: 80%;
  }

  .text-multiplier {
    width: 505px;
    text-align: center;
  }

  .green {
    font-size: 40px;
  }
}

@media screen and (max-width: 800px) {
  .table-thaicuisine {
    background-size: 664px 685px;
    width: 664px;
    height: 685px;
    transform: translate(0px, -108px);
  }

  .top-reel {
    width: 67%;
    transform: translate(111px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-111px, 0px);
  }

  .icon-symbol.-level1 {
    width: 110px;
    height: 92px;
  }

  .icon-symbol.-level2 {
    width: 111px;
    height: 183px;
  }

  .icon-symbol.-level3 {
    width: 111px;
    height: 275px;
  }

  .icon-symbol.-level4 {
    width: 111px;
    height: 367px;
  }
}

@media screen and (max-width: 780px) {
  .top-reel {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 67%;
    transform: translate(105px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }
}

@media screen and (max-width: 600px) {
  .table-thaicuisine {
    background-size: 498px 520px;
    width: 498px;
    height: 520px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 67%;
    transform: translate(82px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-83px, 0px);
  }

  .icon-symbol.-level1 {
    width: 83px;
    height: 70px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 138px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 83px;
    height: 275px;
  }
}

@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-thaicuisine>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-thaicuisine {
    font-size: 12px;
  }

  .table-thaicuisine {
    background-size: 300px 315px;
    width: 300px;
    height: 315px;
    transform: translate(0px, -160px);
  }

  .text-subhead-thaicuisine {
    font-size: 14px;
  }

  .bet-box-thaicuisine {
    min-width: 230px;
    max-width: auto;
    height: 100%;
  }

  .bonus-box-thaicuisine {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-thaicuisine,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-thaicuisine {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-thaicuisine {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(62px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-63px, 0px);
  }

  .icon-symbol.-level1 {
    width: 63px;
    height: 52px;
  }

  .icon-symbol.-level2 {
    width: 63px;
    height: 104px;
  }

  .icon-symbol.-level3 {
    width: 63px;
    height: 155px;
  }

  .icon-symbol.-level4 {
    width: 63px;
    height: 207px;
  }

  .green {
    font-size: 18px;
  }

  .text-win {
    height: 57px;
  }
}

@media screen and (max-width: 550px) {
  .fg-image {
    width: 390px;
  }

  .wheel-wrapper {
    width: 396px;
  }

  .container {
    padding-bottom: 67px;
  }

  .win-box {
    width: 760px;
  }

  .green {
    font-size: 19px;
  }
}

.multiplier-text {
  font-size: 8vw;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: yellow;
  font-weight: 500;
}
</style>
